/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'

import {
  SvgIcon,
  TextArea,
  Spinner,
  InfoDisplay
} from '../'

class ClientNotes extends React.Component {
  static propTypes = {
    client: PropTypes.string.isRequired,
    readOnly: PropTypes.bool
  }

  static defaultProps = {
    readOnly: false
  }

  state = {
    editClientNotes: false,
    saveInProgress: false
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.data.client) {
      this.setState({ clientNotes: props.data.client.notes })
    }
  }

  goReadOnly = () => {
    this.setState({
      editClientNotes: false,
      saveInProgress: false
    })
  }

  goEditNote = () => {
    this.setState({
      editClientNotes: true
    })
  }

  handleNotesUpdate = () => {
    let payload = {
      id: this.props.data.client.id,
      notes: this.state.clientNotes
    }

    if (this.props.data.client.notes !== this.state.clientNotes) {
      this.props.editClientNotes({ variables: { input: payload }})
        .then(this.goReadOnly)
        .catch(() => this.setState({ saveInProgress: false }))
    } else {
      this.goReadOnly()
    }
  }

  noChangesToSave = () => (
    this.props.data.client.notes === this.state.clientNotes
  )

  render() {
    if (this.props.data.loading) {
      return <Spinner className="slds-is-relative" />
    }

    if (this.props.data.error) {
      return (
        <InfoDisplay
          title="Notes"
          rows={
            <tbody>
              <tr>
                <td>
                  <SvgIcon
                    variant="utility"
                    symbol="warning"
                    colour="error"
                    size="x-small"
                    className="slds-m-right_small"
                  />
                  An error occurred loading client notes
                </td>
              </tr>
            </tbody>}
          goReadOnly={true}
          className='slds-m-bottom_x-large'
        />
      )
    }

    const client = this.props.data.client

    return (
      <InfoDisplay
        title="Notes"
        rows={
          <tbody>
            <tr>
              <td>
                {this.state.editClientNotes
                  ? <TextArea
                      value={this.state.clientNotes}
                      onChange={(e) => this.setState({ clientNotes: e.target.value })}
                    />
                  : client.notes || "none"
                }
              </td>
            </tr>
          </tbody>
        }
        edit={this.state.editClientNotes}
        onCancelClick={this.goReadOnly}
        onSaveClick={this.handleNotesUpdate}
        onEditClick={this.goEditNote}
        saveDisabled={this.noChangesToSave() || this.state.saveInProgress}
        saveButtonLabel={this.state.saveInProgress ? 'Saving...' : null}
        noButtons={this.props.readOnly}
        className='slds-m-bottom_x-large'
      />
    )
  }
}

const getClientNotes = gql`query($id: ID!) {
    client(id: $id) {
      id
      notes
    }
  }
`

const editClientNotes = gql`
  mutation editClientNotes($input: ClientMutationInput!) {
    clientMutate(input: $input) {
      client {
        id
        notes
      }
    }
  }
`

const withData =
  graphql(getClientNotes, {
    options: (ownProps) => ({
      variables: {
        id: ownProps.client
      }
    })
  })

const withUpdate =
  graphql(editClientNotes, {
    name: 'editClientNotes'
  })

export default compose(
  withData,
  withUpdate
)(ClientNotes)



// WEBPACK FOOTER //
// ./src/components/client-notes/index.js